import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { dismissError } from '../../../utils/errorDispatchers';
import { motion, AnimatePresence } from 'framer-motion';
import styles from './ErrorToast.module.css';

const ErrorToast = ({ id, message, autoDismiss = true, dismissTime = 5000 }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  // Auto-dismiss the toast after a timeout
  useEffect(() => {
    if (autoDismiss) {
      const timer = setTimeout(() => {
        dismissError(dispatch, id);
      }, dismissTime);

      return () => clearTimeout(timer); // Clear timeout if the component unmounts
    }
  }, [dispatch, id, autoDismiss, dismissTime]);

  return (
    <AnimatePresence>
      <motion.div
        className={styles.errorToast}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 20 }}
        transition={{ duration: 0.3 }}
      >
        <p>{message}</p>
        <button
          onClick={() => dismissError(dispatch, id)}
          className={styles.dismissButton}
        >
          {t('dismiss')}
        </button>
      </motion.div>
    </AnimatePresence>
  );
};

export default ErrorToast;
